// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDependentRequestDto
 */
export interface IDependentRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IDependentRequestDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    suffix?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    gender_type: IDependentRequestDtoGenderTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IDependentRequestDto
     */
    birth_on: Date;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    relationship_type: IDependentRequestDtoRelationshipTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentRequestDto
     */
    creation_source_type: IDependentRequestDtoCreationSourceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDependentRequestDtoGenderTypeEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}
/**
* @export
* @enum {string}
*/
export enum IDependentRequestDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}
/**
* @export
* @enum {string}
*/
export enum IDependentRequestDtoCreationSourceTypeEnum {
    UNKNOWN = 'UNKNOWN',
    API = 'API',
    MOBILE = 'MOBILE',
    WEB_PARTICIPANT_PORTAL = 'WEB_PARTICIPANT_PORTAL',
    WEB_ADMIN_PORTAL = 'WEB_ADMIN_PORTAL',
    DEPENDENT = 'DEPENDENT',
    CARRIER = 'CARRIER',
    CENSUS = 'CENSUS'
}


/**
 * Check if a given object implements the IDependentRequestDto interface.
 */
export function instanceOfIDependentRequestDto(value: object): value is IDependentRequestDto {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('gender_type' in value) || value['gender_type'] === undefined) return false;
    if (!('birth_on' in value) || value['birth_on'] === undefined) return false;
    if (!('relationship_type' in value) || value['relationship_type'] === undefined) return false;
    if (!('creation_source_type' in value) || value['creation_source_type'] === undefined) return false;
    return true;
}

export function IDependentRequestDtoFromJSON(json: any): IDependentRequestDto {
    return IDependentRequestDtoFromJSONTyped(json, false);
}

export function IDependentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDependentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'first_name': json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'gender_type': json['gender_type'],
        'birth_on': (new Date(json['birth_on'])),
        'relationship_type': json['relationship_type'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'creation_source_type': json['creation_source_type'],
    };
}

export function IDependentRequestDtoToJSON(json: any): IDependentRequestDto {
    return IDependentRequestDtoToJSONTyped(json, false);
}

export function IDependentRequestDtoToJSONTyped(value?: IDependentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'ssn': value['ssn'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'gender_type': value['gender_type'],
        'birth_on': ((value['birth_on']).toISOString().substring(0,10)),
        'relationship_type': value['relationship_type'],
        'external_identifier': value['external_identifier'],
        'creation_source_type': value['creation_source_type'],
    };
}

